import { createSlice } from '@reduxjs/toolkit';

const sessionSlice = createSlice({
  name: 'session',
  initialState: JSON.parse(sessionStorage.getItem('sessionData')) || {},
  reducers: {
    setSession(state, action) {
      return { ...state, ...action.payload };
    },
    clearSession() {
      return {};
    },
  },
});

export const { setSession, clearSession } = sessionSlice.actions;
export default sessionSlice.reducer;